module.exports = __webpack_public_path__ + "media/images/front/founders/mima-873748a00f658dc0f00d03632539c9e6.jpg";